var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Row', {
    staticClass: "info-row"
  }, [_c('Col', {
    staticClass: "cost-key",
    attrs: {
      "span": "13"
    }
  }, [_vm._v(_vm._s(_vm.field))]), _c('Col', {
    staticClass: "cost-price",
    attrs: {
      "span": "6"
    }
  }, [_vm._v(_vm._s(_vm.displayValue))]), _c('Col', {
    style: _vm.diffStyle,
    attrs: {
      "span": "5"
    }
  }, [_vm._v(_vm._s(_vm.displayDiffValue))])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }